<template>
  <cargo-advance-select
    :disabled="disabled"
    :select-type="selectTypeNames.static_data_Project"
    tag-name="_label"
    :cache="false"
    filterable
    :show-origin-value="true"
    :default-value="defaultValue"
    :static-options="staticOptions"
    :placeholder="placeholder||undefined"
    @parentCallBack="p=>{$emit('change',p)}"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getAllProject, getAllProjectByCon } from '@/api/projectManage/project'
import * as ProjectManageState from '@/class/cargo/model/parameters/ProjectManageState'

export default {
  name: 'CargoProjectSelect',
  components: { cargoAdvanceSelect },
  props: {
    disabled: { type: Boolean, default: false },
    defaultValue: { type: [String, Number, Boolean], default: '' },
    placeholder: { type: String, default: '' },
    customerId: { type: Number, default: 0 },
    isLinked: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      options: [],
      newOptions: [],
      allProjectList: []
    }
  },
  computed: {
    staticOptions() {
      return (this.newOptions && this.newOptions.length > 0) ? this.newOptions : this.options
    }
  },
  watch: {
    defaultValue: {
      handler(newVal) {
        if (newVal) {
          this.setCurPoNo()
        }
      }
    },
    customerId: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.refreshProjectList()
        } else {
          this.options = [...this.allProjectList]
          this.setCurPoNo()
        }
      }
    }
  },
  async created() {
    const param = {
      lob: this.lob,
      anyInteger: Number(ProjectManageState.IP_STATE_DETAIL.code)
    }
    getAllProjectByCon(param).then(res => {
      this.allProjectList = [...res.data]
      this.options = res.data
      for (const item of this.options) {
        item._label = item.projectNo + ' ' + item.projectName
      }
    })
  },
  methods: {
    // 当前项目编号如果不是进行中，则需要加进数组中
    setCurPoNo() {
      this.newOptions = []
      if (!this.defaultValue || !this.options) return
      let flag = false
      for (const item of this.options) {
        if (!item.projectNo) continue
        if (item.projectNo === this.defaultValue) {
          flag = true
          return
        }
      }
      // 没找到
      if (!flag) {
        const poNo = {
          _label: this.defaultValue,
          projectNo: this.defaultValue,
          projectName: ''
        }
        this.newOptions = [...this.options]
        this.newOptions.push(poNo)
      }
    },
    refreshProjectList() {
      if (!this.isLinked) {
        return
      }
      const param = {
        lob: this.lob,
        anyInteger: Number(ProjectManageState.IP_STATE_DETAIL.code),
        partener: this.customerId
      }
      getAllProjectByCon(param).then(res => {
        this.options = res.data
        for (const item of this.options) {
          item._label = item.projectNo + ' ' + item.projectName
        }
      })
    }
  }
}
</script>

<style>
</style>
